import * as React from 'react';
import { Column } from "react-table";
import Table from "../../components/table/Table";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import type { IPlace } from "./types";
import Page from "../../components/layout/Page";
import { useListPage } from "../../hooks";
import RowActions from "../../components/table/RowActions";
import CreateButton from "../../components/common/CreateButton";
import TableIndicator from "../../components/common/TableStatus";

interface IAddressRecord extends Pick<IPlace, 'address' | '_id' | 'lastInstalledGroupNumberLabel' | 'phoneNumber' | 'title' | 'isFeatured' | 'featuredOrder'>{
    actions: unknown;
}

const PlaceList = () => {

    const { records, handleInteraction, paginationState, deleteRecord } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<IAddressRecord>[] =  [
        {
            Header: 'Байгууллагын нэр',
            accessor: 'title',
            defaultCanSort: true
        },
        {
            Header: '⭐',
            accessor: 'featuredOrder',
            Cell: ({ value, row }) => {
                if (!row?.original?.isFeatured) {
                    return null;
                }
                return (
                    <div>
                        {row?.original?.featuredOrder ?? null}
                    </div>
                );
            },
            width: 1
        },
        {
            Header: 'Утасны дугаар',
            accessor: 'phoneNumber',
        },
        {
            Header: 'Урын сан',
            accessor: 'lastInstalledGroupNumberLabel',
        },
        {
            Header: 'Хаяг',
            accessor: 'address',
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} deleteRecord={deleteRecord} clientRoute={CLIENT_ROUTE} />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE}: ${paginationState.totalDocuments}`}>
                <CreateButton route={CLIENT_ROUTE}/>
            </Page.Header>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default PlaceList;